export const DESCRIPTION_PARAMETER_KEY = 'Описание';
